const objFromArray = (arr, key = 'id') => arr.reduce((accumulator, current) => {
  /* eslint-disable-next-line no-param-reassign */
  accumulator[current[key]] = current;
  return accumulator;
}, {});

export default objFromArray;
